export default {
  navbar: {
    home: "होम",
    roles: "भूमिकाएँ",
    features: "विशेषताएं",
    whyUs: "क्यों चुनें",
    contactUs: "संपर्क करें",
  },
  home: {
    TeachWings: "टीचविंग्स",
    comprehensive: "व्यापक",
    modules: "मॉड्यूल",
    for: "के लिए",
    schoolManagement: "स्कूल प्रबंधन",
    customized: "स्वनिर्धारित",
    userAcees: "उपयोगकर्ता की पहुंच",
    heading_01: "ऊंची उड़ान भरें के साथ",
    how: "कैसे",
    works: "काम करता है",
    why_choose: "क्यों चुनें",
    heading_02: "आपके स्कूल की सभी ज़रूरतों के लिए एकीकृत तकनीकी भागीदार",
    sub_heading_01: "सहज स्कूल प्रबंधन.",

    para_01:
      "टिचविंग्स के साथ अपने स्कूल के संचालन को क्रांतिकारी बनाएं, जो कि एक ऑल-इन-वन स्कूल प्रबंधन समाधान है। छात्रों, अभिभावकों, शिक्षकों और प्रशासकों की ज़रूरतों को ध्यान में रखते हुए डिज़ाइन किया गया, टिचविंग्स संचार, शिक्षा और प्रशासनिक कार्यों को सरल बनाता है, जिससे स्कूल संचालन अधिक कुशल, पारदर्शी और सुरक्षित हो जाते हैं।",
    heading_03: "टीचविंग्स के बारे में",
    superAdmin: "सुपर एडमिन",
    admin: "एडमिन",
    receptionist: "रिसेप्शनिस्ट",
    librarian: "पुस्तकालयाध्यक्ष",
    classTeacher: "क्लास टीचर",
    teacher: "शिक्षक",
    student: "छात्र",
    parent: "अभिभावक",
    heading_04: "टिचविंग्स के बारे में",
    para_03:
      "टिचविंग्स का उद्देश्य स्कूल प्रबंधन को सरल और छात्रों, अभिभावकों, शिक्षकों और प्रशासकों को सशक्त बनाना है। हमारा मिशन एक सुरक्षित, सहज प्लेटफ़ॉर्म प्रदान करना है जो संचार को सरल बनाए, शिक्षा को बेहतर बनाए और प्रशासनिक कार्यों को स्वचालित करे। टिचविंग्स के साथ, हम दुनिया भर के स्कूलों को ऐसी तकनीक अपनाने में मदद कर रहे हैं जो शैक्षिक परिणामों को बेहतर बनाती है, प्रशासनिक बोझ को कम करती है और सहयोगात्मक वातावरण को बढ़ावा देती है। टिचविंग्स के साथ उड़ान भरें और समय बचाएं।",
    heading_05: "टिचविंग्स की प्रमुख विशेषताएं",
    card_heading_01: "प्रशासक",
    card_heading_02: "शिक्षक",
    card_heading_03: "छात्र",
    card_heading_04: "अभिभावक",

    card_para_01:
      "प्रवेश प्रक्रिया को आसान बनाएं, उपयोगकर्ताओं, समय-सारिणी, शुल्क, परिवहन को प्रबंधित करें और कुशल संचालन और सूचित निर्णयों के लिए उपयोगी रिपोर्ट जनरेट करें।",
    card_para_02:
      "कक्षाओं को प्रबंधित करें, प्रदर्शन का ट्रैक रखें, ग्रेड दें और प्रभावी ढंग से जुड़ें।",
    card_para_03:
      "ग्रेड, समय-सारिणी, असाइनमेंट, परीक्षाएं और संसाधन आसानी से एक्सेस करें।",
    card_para_04:
      "प्रगति, उपस्थिति, शुल्क के बारे में अपडेट रहें और बिना किसी परेशानी के संवाद करें।",

    keyFeatures: {
      list_01:
        "व्यापक उपयोगकर्ता प्रबंधन: शिक्षकों, छात्रों, स्टाफ और माता-पिता को प्रबंधित करें और भूमिकाओं और अनुमतियों पर पूर्ण नियंत्रण रखें।",
      list_02: "नए प्रवेश और शैक्षणिक सत्र प्रबंधन।",
      list_03:
        "समय सारणी बनाएं और अपडेट करें: कक्षाओं, परीक्षाओं और स्कूल आयोजनों के लिए समय सारिणी आसानी से सेट करें।",
      list_04:
        "शुल्क और वित्तीय प्रबंधन: स्कूल वित्त का निरीक्षण करें, शुल्क संरचना का प्रबंधन करें और भुगतान को प्रभावी रूप से ट्रैक करें।",
      list_05: "परिवहन प्रबंधन: परिवहन प्रबंधन अनुपालन और सुरक्षा बनाए रखते हुए छात्र परिवहन के लिए बसों की सुरक्षित, कुशल रूटिंग, ट्रैकिंग और समय-निर्धारण सुनिश्चित करता है।",
      list_06:
        "डेटा-आधारित रिपोर्ट्स: उपस्थिति, प्रदर्शन, वित्त और अन्य पर विस्तृत रिपोर्ट और विश्लेषण उत्पन्न करें।",
      list_07:
        "कक्षाएं और असाइनमेंट प्रबंधित करें: कक्षाएं, असाइनमेंट और पाठ योजना एक ही स्थान पर व्यवस्थित करें।",
      list_08: "उपस्थिति प्रबंधन: कक्षा उपस्थिति रिकॉर्ड और ट्रैकिंग।",
      list_09:
        "छात्र प्रगति पर नज़र रखें: व्यक्तिगत छात्र प्रदर्शन देखें और समय पर प्रतिक्रिया प्रदान करें।",
      list_10:
        "ग्रेड बुक और रिपोर्ट कार्ड: तेजी से ग्रेड दर्ज करें, रिपोर्ट कार्ड उत्पन्न करें और छात्र प्रदर्शन का मूल्यांकन करें।",
      list_11:
        "संचार उपकरण: अंतर्निर्मित मैसेजिंग सिस्टम के माध्यम से सीधे छात्रों और माता-पिता से जुड़ें।",
      list_12:
        "ग्रेड और रिपोर्ट कार्ड ट्रैक करें: अपने ग्रेड, असाइनमेंट और प्रदर्शन अपडेट तक तुरंत पहुंच प्राप्त करें।",
      list_13:
        "समय सारणी और अनुसूची देखें: अपने व्यक्तिगत समय सारिणी और आगामी आयोजनों के साथ कभी भी कक्षा न चूकें।",
      list_14:
        "होमवर्क और असाइनमेंट: आसानी से अपने होमवर्क और असाइनमेंट देखें और प्रबंधित करें, समय सीमा और सबमिशन रिमाइंडर के साथ।",
      list_15:
        "परीक्षा अपडेट और परिणाम: परीक्षा कार्यक्रम के साथ अद्यतन रहें, और जैसे ही उपलब्ध हों परिणाम प्राप्त करें।",
      list_16:
        "शिक्षा संसाधन: डिजिटल अध्ययन सामग्री, पाठ योजना और शिक्षकों से किसी भी समय, कहीं भी नोट्स तक पहुंच प्राप्त करें।",
      list_17:
        "ग्रेड और रिपोर्ट कार्ड ट्रैक करें: अपने ग्रेड, असाइनमेंट और प्रदर्शन अपडेट तक तुरंत पहुंच प्राप्त करें।",
      list_18:
        "समय सारणी और अनुसूची देखें: अपने व्यक्तिगत समय सारिणी और आगामी आयोजनों के साथ कभी भी कक्षा न चूकें।",
      list_19:
        "होमवर्क और असाइनमेंट: आसानी से अपने होमवर्क और असाइनमेंट देखें और प्रबंधित करें, समय सीमा और सबमिशन रिमाइंडर के साथ।",
      list_20:
        "परीक्षा अपडेट और परिणाम: परीक्षा कार्यक्रम के साथ अद्यतन रहें, और जैसे ही उपलब्ध हों परिणाम प्राप्त करें।",
      list_21:
        "शिक्षा संसाधन: डिजिटल अध्ययन सामग्री, पाठ योजना और शिक्षकों से किसी भी समय, कहीं भी नोट्स तक पहुंच प्राप्त करें।",
    },

    heading_06: "टिचविंग्स कैसे काम करता है",
    card_heading_05: "साइन अप करें",
    card_heading_06: "अपनी प्रोफ़ाइल सेट करें",
    card_heading_07: "विशेषताओं का उपयोग शुरू करें",
    card_heading_08: "कनेक्टेड रहें",
    card_para_05:
      "अपना स्कूल पंजीकृत करें और सदस्यता चुनें।",
    card_para_06:
      "अपना डैशबोर्ड व्यक्तिगत बनाएं और अपनी भूमिका और प्राथमिकताओं के आधार पर सेटिंग्स कॉन्फ़िगर करें।",
    card_para_07:
      "तुरंत सभी मुख्य विशेषताओं जैसे ग्रेड, असाइनमेंट, संचार उपकरण, समय-सारिणी और अधिक तक पहुंच प्राप्त करें।",
    card_para_08:
      "ग्रेड, उपस्थिति और स्कूल समाचार पर वास्तविक समय के अपडेट प्राप्त करें। सीधे शिक्षकों और अभिभावकों के साथ संवाद करें, सब कुछ ऐप के भीतर।",
    heading_07: "टिचविंग्स क्यों चुनें?",
    whyChoose: {
      list_01:
        "सरल स्कूल संचालन: कक्षा कार्यक्रमों और उपस्थिति से लेकर ग्रेड और शुल्क तक सब कुछ एकल, उपयोग में आसान प्लेटफ़ॉर्म में प्रबंधित करें।",
      list_02:
        "बेहतर संचार: सभी उपयोगकर्ताओं के लिए रीयल-टाइम सूचनाओं, सीधे संदेशों और त्वरित अपडेट के साथ सूचित रहें।",
      list_03:
        "समय बचाने वाला स्वचालन: ग्रेडिंग, उपस्थिति ट्रैकिंग और शुल्क अनुस्मारक जैसी कार्यों को स्वचालित करें, जिससे आप वास्तव में महत्वपूर्ण चीज़ों पर ध्यान केंद्रित कर सकें—शिक्षा।",
      list_04:
        "सुरक्षित और निजी: आपका डेटा हमारे साथ सुरक्षित है। टिचविंग्स उच्चतम डेटा सुरक्षा और गोपनीयता मानकों का पालन करता है।",
      list_05:
        "आपके स्कूल के लिए अनुकूलित: अपने स्कूल की अनूठी ज़रूरतों को पूरा करने के लिए प्लेटफ़ॉर्म को अनुकूलित करें, जिसमें लचीली विशेषताएं और सेटिंग्स शामिल हैं।",
    },
  },

  keyFeatures: {
    heading: {
      w1: "Key Features ",
      w2: "of TeachWings",
    },
    adminFeat: {
      h1: "Administrator",
    },
    teacherFeat: {
      h1: "Teachers",
    },
    studentFeat: {
      h1: "Students",
    },
    parentFeat: {
      h1: "Parents",
    },
  },

  contactUs: {
    heading_01: "हमें एक संदेश छोड़ें या इस पते पर ईमेल भेजें",
    name: "नाम",
    email: "ईमेल",
    contactNumber: "संपर्क नंबर",
    message: "संदेश",
    cancel: "रद्द करें",
    submit: "प्रस्तुत करें",
  },

  readMore: {},

  common: {
    getStarted: "शुरू हो जाओ",
    and: "और",
    registerNow: "अभी रजिस्टर करें",
    loginNow: "अभी लॉगिन करें",
    knowMore: "और जानें",
    learnMore: "अधिक जानें",
  },
  footer: {
    availableOn: "पर उपलब्ध",
    contactEnquiry: "संपर्क / पूछताछ",
    navigate: "नेविगेट करें",
    usefullLinks: "उपयोगी कड़ियां",
    footer_para:
      "क्या आपके पास कोई प्रश्न है या सहायता चाहिए? एक डेमो के लिए या अधिक जानकारी के लिए हमसे संपर्क करें।",
    allRightsReserved: "सभी अधिकार सुरक्षित।",
    playStore: "प्ले स्टोर",
    home: "होम",
    features: "विशेषताएं",
    whyUs: "क्यों चुनें",
    contactUs: "संपर्क करें",
    appStore: "ऐप स्टोर",
    register: "पंजीकरण करें",
    login: "लॉगिन",
  },
  privacy: {
    h1: "गोपनीयता नीति",
  },
};
